import { render, staticRenderFns } from "./GroupSettingPopup.vue?vue&type=template&id=5dcddbb6&"
import script from "./GroupSettingPopup.vue?vue&type=script&lang=js&"
export * from "./GroupSettingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports